module.exports = __webpack_public_path__ + "img/DW365-136.40844a49.jpg";